"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithDefaultEmailArgs = exports.ForgotPassword = exports.ForgotPasswordArgs = void 0;
var get_component_1 = require("../../shared/helpers/get-component");
var forgot_password_form_1 = require("./forgot-password.form");
// New School Year Args and Component
exports.ForgotPasswordArgs = {
    onSubmit: function (formValues) {
        // Default - Just log the values to the console
        console.debug(formValues);
    },
};
exports.ForgotPassword = (0, get_component_1.getComponent)(forgot_password_form_1.ForgotPasswordForm, exports.ForgotPasswordArgs);
exports.WithDefaultEmailArgs = {
    email: 'RTeacher123@AOL.com',
};
